import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    background: '#E3E8F2',
    height: 55,
    width: '100%',
    position: 'sticky',
    top: 65,
    zIndex: 3,
    marginTop: -15,
    [theme.breakpoints.down("xs")]: {
      top: 56,
      marginTop: -24,
    },
  },
  pageHeader: {
    // textTransform: 'capitalize',
  },
  headerAction: {
    [theme.breakpoints.down("xs")]: {
      textAlign: 'right',
      width: '100%',
      height: 55,
      paddingTop: 10,
    },
  },
  navBtn: {
    "& button": {
      background: '#fff',
      marginLeft: 8
    }
  }
}));

export default useStyles;
